var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { Link, useLocation } from "react-router-dom";
import { PHASE } from "../routeConfig";
import { UnlinkedApplicationStatus } from "../features/unlinked-application/unlinkedApplicationSlice";
import { allVehiclesHaveData } from "../utils/validateUnlinkedVehiclesData";
import classNames from "classnames";
import { getMatchingPath } from "../utils/typeUtils";
import useAppSelector from "../hooks/useAppSelector";
import { validateDrivers } from "../features/unlinked-application/utils";
import { validateUnlinkedApplicantAddress } from "../features/unlinked-application/validateUnlinkedApplicantAddress";
export function Header(_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("h2", __assign({ className: classNames("text-xl font-bold", className) }, rest)));
}
export function ScrollingContainer(_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("div", __assign({ className: classNames("flex grow flex-col overflow-y-auto overflow-x-hidden px-6", className) }, rest)));
}
export function ListItem(_a) {
    var icon = _a.icon, primaryText = _a.primaryText, secondaryText = _a.secondaryText;
    return (React.createElement("li", { className: "relative" },
        React.createElement("div", { className: "flex w-full items-center py-2 text-left" },
            icon ? (React.createElement("div", { className: "mr-2 flex h-8 w-8 flex-none items-center justify-center" }, icon)) : null,
            React.createElement("div", { className: "flex grow flex-col" },
                React.createElement("div", { className: "font-bold" }, primaryText),
                React.createElement("div", { className: "text-sm text-black-300" }, secondaryText)))));
}
export function ListItemWithActionButtons(_a) {
    var primaryText = _a.primaryText, secondaryText = _a.secondaryText, tertiaryText = _a.tertiaryText, icon = _a.icon, actionButtons = _a.actionButtons, onClick = _a.onClick;
    var Container = onClick ? "button" : "div";
    var containerProps = onClick
        ? {
            onClick: onClick,
            className: "flex w-full items-center space-x-4 py-2 text-left",
        }
        : { className: "flex w-full items-center space-x-4 py-2 text-left" };
    return (React.createElement("li", { className: "relative" },
        React.createElement("div", { className: "flex w-full items-center text-left" },
            React.createElement(Container, __assign({}, containerProps),
                icon ? (React.createElement("div", { className: "flex h-8 w-8 flex-none items-center justify-center" }, icon)) : null,
                React.createElement("div", { className: "flex grow flex-col" },
                    React.createElement("div", { className: "font-bold" }, primaryText),
                    React.createElement("div", { className: "text-sm leading-none text-black-300" }, secondaryText),
                    tertiaryText ? (React.createElement("div", { className: "text-sm leading-none" }, tertiaryText)) : null)),
            React.createElement("div", { className: "flex items-center" }, actionButtons === null || actionButtons === void 0 ? void 0 : actionButtons.map(function (button, index) { return (React.createElement("span", { key: index },
                " ",
                button,
                " ")); })))));
}
export function ListItemActionButton(props) {
    var onClick = props.onClick, icon = props.icon, _a = props.isVisible, isVisible = _a === void 0 ? true : _a, rest = __rest(props, ["onClick", "icon", "isVisible"]);
    return isVisible ? (React.createElement("button", __assign({ type: "button", className: "ml-3", onClick: onClick }, rest),
        React.createElement("span", null, icon))) : null;
}
export function ListButtonItem(_a) {
    var primaryText = _a.primaryText, secondaryText = _a.secondaryText, icon = _a.icon, secondaryIcon = _a.secondaryIcon, onClick = _a.onClick;
    return (React.createElement("li", { className: "relative" },
        React.createElement("button", { type: "button", className: "flex w-full items-center space-x-4 py-2 text-left", onClick: onClick },
            icon ? (React.createElement("div", { className: "flex h-8 w-8 flex-none items-center justify-center" }, icon)) : null,
            React.createElement("div", { className: "flex grow flex-col" },
                React.createElement("div", { className: "font-bold" }, primaryText),
                React.createElement("div", { className: "text-sm leading-none text-black-300" }, secondaryText)),
            React.createElement("div", { className: "flex items-center" },
                secondaryIcon ? React.createElement("span", { className: "mr-2" }, secondaryIcon) : null,
                React.createElement("span", { className: "text-sm leading-none text-black-300" }, "Edit"),
                React.createElement("svg", { width: "16", height: "17", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("path", { d: "M5.33341 13.167L10.6667 8.16699L5.33341 3.16699", stroke: "#666666" }))))));
}
export var AutoProgressBarTitles;
(function (AutoProgressBarTitles) {
    AutoProgressBarTitles["Vehicles"] = "Vehicles";
    AutoProgressBarTitles["Drivers"] = "Drivers";
    AutoProgressBarTitles["Review"] = "Review";
})(AutoProgressBarTitles || (AutoProgressBarTitles = {}));
export var HomeProgressBarTitles;
(function (HomeProgressBarTitles) {
    HomeProgressBarTitles["Home"] = "Home";
    HomeProgressBarTitles["Premium"] = "Premium";
})(HomeProgressBarTitles || (HomeProgressBarTitles = {}));
var autoProgressItems = [
    {
        title: AutoProgressBarTitles.Vehicles,
        activePath: [
            PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES,
            PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES_EDIT_YEAR,
            PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES_EDIT_MAKE,
            PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES_EDIT_MODEL,
            PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES_EDIT_TRIM,
            PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES_EDIT_STATUS,
            PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES_EDIT_FULL_COVERAGE,
        ],
        isComplete: function (state) {
            return allVehiclesHaveData(state.auto.vehicles, {
                isPrefill: state.prefill.auto.data || state.prefill.home.data,
            });
        },
    },
    {
        title: AutoProgressBarTitles.Drivers,
        activePath: [
            "/auto/unlinked-application/drivers",
            "/auto/unlinked-application/applicable-discounts",
            PHASE.UNLINKED_APPLICATION_AUTO_MILITARY,
            "/auto/unlinked-application/premium",
        ],
        isComplete: function (state) {
            return validateDrivers(state.auto.drivers);
        },
    },
    {
        title: AutoProgressBarTitles.Review,
        activePath: ["/auto/unlinked-application/review"],
        isComplete: function (state) {
            return state.status.auto === UnlinkedApplicationStatus.Complete;
        },
    },
];
var homeProgressItems = [
    {
        title: HomeProgressBarTitles.Home,
        activePath: [
            "/home/unlinked-application/property-address",
            PHASE.UNLINKED_APPLICATION_HOMEOWNERS_MILITARY,
        ],
        isComplete: function (state) {
            return Boolean(validateUnlinkedApplicantAddress(state.homeowners));
        },
    },
    {
        title: HomeProgressBarTitles.Premium,
        activePath: ["/home/unlinked-application/premium"],
        isComplete: function (state) {
            return state.status.home === UnlinkedApplicationStatus.Complete;
        },
    },
];
export function Progress() {
    var location = useLocation();
    var state = useAppSelector(function (state) { return state.unlinkedApplication; });
    var currentPath = location.pathname;
    var progressItems = React.useMemo(function () {
        if (currentPath.includes("/auto/unlinked-application")) {
            return autoProgressItems;
        }
        else if (currentPath.includes("/home/unlinked-application")) {
            return homeProgressItems;
        }
        else {
            return [];
        }
    }, [currentPath]);
    return (React.createElement("nav", { className: "mx-auto mb-3 mt-auto flex select-none justify-center pt-4" },
        React.createElement("ol", { className: classNames("mb-0 flex items-center space-x-5 bg-white") }, progressItems.map(function (item, index) {
            var _a;
            var matchingPath = getMatchingPath(currentPath, item.activePath);
            var isActive = Boolean(matchingPath);
            var isComplete = item.isComplete(state);
            var isInitialPath = (_a = progressItems[0]) === null || _a === void 0 ? void 0 : _a.activePath.includes(currentPath);
            var isCompleteAndNotActive = isComplete && !isActive;
            var isNotActiveAndNotComplete = !isActive && !isComplete;
            var isActiveOrNotComplete = !isComplete || isActive;
            var isActiveOrComplete = isActive || isComplete;
            return (React.createElement("li", { className: "relative flex flex-col items-center font-semibold leading-none", key: item.title },
                !isActive ? (React.createElement(Link, { to: item.activePath[0] },
                    React.createElement("span", { className: classNames("mb-1 text-sm capitalize leading-none", {
                            "text-savvy": isActive,
                            "text-black-300": isCompleteAndNotActive,
                            "text-gray-200": isNotActiveAndNotComplete,
                        }) }, item.title))) : (React.createElement("span", { className: classNames("mb-1 text-sm capitalize leading-none", {
                        "text-savvy": isActive,
                        "text-black-300": isCompleteAndNotActive,
                        "text-gray-200": isNotActiveAndNotComplete,
                    }) }, item.title)),
                index + 1 !== progressItems.length ? (React.createElement("span", { className: classNames("absolute left-1/2 top-[19px] z-10 h-[2px] w-[68px]", {
                        "bg-savvy": isCompleteAndNotActive,
                        "bg-white-300": isActiveOrNotComplete || isInitialPath,
                    }) })) : null,
                React.createElement("span", { className: classNames("relative z-20 mb-2 flex h-2 w-2 items-center justify-center rounded-full border-2 text-[10px] leading-none", {
                        "border-gray-200 bg-gray-200": isNotActiveAndNotComplete,
                        "border-savvy bg-savvy-100": isActiveOrComplete,
                    }) })));
        }))));
}
